export const giftCard = {
	tabs: {
		campaigns: "Campañas",
		metabase: "Desempeño",
	},
	pageTitleList: "Gift Card",
	pageSubtitle: "Configure su Gift Card para campañas.",
	modalTitle: "Gift Cards",
	modalDescription:
		"Campaña creada con éxito. Ahora puede exportar el archivo para canjear los cupones.",
	manageGiftCardModal: {
		title: {
			active: "Activar campaña",
			inactive: "Desactivar campaña",
		},
		description: {
			active: "Activando campaña ({{campaign}}), ¿continuar?",
			inactive: "Desactivando campaña ({{campaign}}), ¿continuar?",
		},
	},
	fields: {
		campaignName: "Nombre de la campaña",
		campaignPlaces: "Local",
		campaignCreatedAt: "Fecha de creación",
		numberOfGifts: "Cant. de cupones",
		giftCardValue: "Valor unitario",
		giftCardExpirationDate: "Fecha de expiración",
		giftCardRedeemed: "Canjeado",
		validation: {
			campaignNameAlreadyExists: "Este nombre de campaña ya existe",
		},
	},
	form: {
		validations: {
			required: "Campo obligatorio",
		},
		messages: {
			successInCreating: "Campaña creada con éxito",
			failedToCreate: "Error al crear la campaña",
			successInCreatingSubtitle:
				"Tenga acceso a todos los códigos de la campaña descargando la hoja a continuación:",
			campaignEdited: "Campaña actualizada",
			campaignEditedFailure: "Error al actualizar la campaña",
		},
	},
	actions: {
		label: "Acciones",
		exportCupons: "Exportar Cupones",
		track: "Seguimiento",
		createCampaign: "Crear campaña",
		inactivate: "Desactivar",
		activate: "Activar",
	},
	status: {
		label: "Estado",
		active: "Activa",
		inactive: "Inactiva",
		expired: "Expirado",
	},
	excel: {
		title: "Gift Cards",
		filename: "gift-cards",
		columns: {
			giftCardcodes: "Códigos",
			giftCardValue: "Valor unitario",
		},
	},
};
